import { PageHead } from "../components/ui";
import { api } from "../api";
import { useMe } from "../session";
import { THEME_LABEL, useTheme, type ThemePref } from "../theme";
import { Navigate, useSearchParams } from "react-router-dom";
import { Companies } from "./Companies";
import { Security } from "./Security";
import { EnvironmentCard } from "../components/EnvironmentCard";
import { NotificationPrefs } from "./settings/NotificationPrefs";
import { CompanyData } from "./settings/CompanyData";
import { GoogleLink } from "../components/GoogleLink";
import { ProfilePhoto } from "../components/ProfilePhoto";

const ALL_TABS = [["geral", "Geral"], ["empresa", "Dados da empresa"], ["avisos", "Avisos"]] as const;
const TABS = ALL_TABS;

/** Configurações: Geral (aparência, empresas, segurança), dados da empresa e avisos. Os cadastros de apoio (categorias, beneficiários e pagadores, memorização) ficam no menu Cadastros. */
export function Settings() {
  const { me } = useMe();
  const { pref, setPref } = useTheme();
  const [sp, setSp] = useSearchParams();
  const tabs = ALL_TABS.filter(([k]) => k !== "empresa" || me.user.realm === "pj");
  const tab = tabs.find(([k]) => k === sp.get("aba"))?.[0] ?? "geral";
  const choose = (t: ThemePref) => { setPref(t); void api("PUT", `/api/${me.user.realm}/preferences/theme`, { theme: t }).catch(() => undefined); };
  const legacy = sp.get("aba");
  if (legacy === "categorias" || legacy === "contrapartes" || legacy === "memorizacao") return <Navigate to={`/${me.user.realm}/cadastros/${legacy}`} replace />;
  return (
    <>
      <PageHead title="Configurações" sub="Sua conta, segurança, aparência e avisos." />
      <div className="seg" role="tablist" aria-label="Seções" style={{ marginBottom: 16 }}>
        {tabs.map(([k, l]) => <button key={k} role="tab" aria-selected={tab === k} aria-pressed={tab === k} data-tab={k} onClick={() => setSp(k === "geral" ? {} : { aba: k }, { replace: true })}>{l}</button>)}
      </div>
      {tab === "empresa" && <CompanyData />}
      {tab === "avisos" && <NotificationPrefs />}
      {tab === "geral" && <>
      <div className="card" style={{ maxWidth: 560, marginBottom: 16 }}>
        <h3 style={{ fontSize: 16, marginBottom: 6 }}>Aparência</h3>
        <p className="muted" style={{ marginTop: 0 }}>Sua preferência é salva na sua conta.</p>
        <div className="seg" role="group" aria-label="Tema">
          {(["claro", "escuro", "automatico"] as const).map((t) => (
            <button key={t} aria-pressed={pref === t} onClick={() => choose(t)} data-theme-option={t}>{THEME_LABEL[t]}</button>
          ))}
        </div>
      </div>
      {me.user.realm === "pf" && <ProfilePhoto realm="pf" />}
      <EnvironmentCard />
      {me.user.realm === "pj" && <Companies />}
      {me.user.realm !== "admin" && <GoogleLink realm={me.user.realm} />}
      <Security embedded />
      </>}
    </>
  );
}
